/**
 * Platform tags the gateway stamps on a conversation, as one definition.
 *
 * A platform tag is written by a channel adapter and read back by surfaces
 * that never run in the same process: the hub-chat adapter puts it in the
 * transcript's sender envelope, and the browser compares it to decide whether a
 * message is the reader's own or someone else's. Two independent spellings of
 * that value type-check perfectly and disagree silently — a renamed channel id
 * leaves the reader's own messages attributed "via …" forever, on the reload
 * path only, which is exactly the defect this module exists to make impossible.
 *
 * Lives in the neutral contracts package for the same reason
 * `gateway-tool-names.ts` does: both ends already depend on it, it carries no
 * runtime, and it is reachable from the browser bundle as well as from Node.
 */
/** The in-Hub chat surface. Written by `@lifter/hub-chat-channel`. */
export const HUB_CHAT_PLATFORM = "hub-chat";
